import React, { useEffect, useState } from "react";

import Modal from "../../components/Modal";
import Button from "../../components/Button";
import Icon from "../../components/Icon";

import api from "../../services/api";

/**
 * Busca no catálogo da marca só produtos de fornecedor: é o que pode virar
 * versão personalizada (o original empresta preço, estoque e cores).
 */
export const SupplierProductPicker = ({ show, close, brandId, title, actionText, onPick, picking }) => {
    const [search, setSearch] = useState('');
    const [appliedSearch, setAppliedSearch] = useState('');
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!show) return;

        setLoading(true);
        api.get(`/brand/${brandId}/catalog`, {
            params: { filter: 'supplier', search: appliedSearch, per_page: 8 }
        }).then(res => {
            setProducts(res.data.resources.data ?? []);
        }).catch(() => {
            setProducts([]);
        }).then(() => setLoading(false));
    }, [show, appliedSearch]);

    useEffect(() => {
        const timeout = setTimeout(() => setAppliedSearch(search.trim()), 400);
        return () => clearTimeout(timeout);
    }, [search]);

    return (
        <Modal title={title} show={show} close={close} className="brand-picker-modal">
            <div className="section">
                <div className="brand-picker-search">
                    <Icon name="search" size={16} />
                    <input
                        type="text"
                        autoFocus
                        placeholder="Buscar por nome ou SKU do fornecedor"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </div>

                <div className="brand-picker-list">
                    {loading && <p className="section-hint">Carregando...</p>}
                    {!loading && products.length === 0 &&
                        <p className="section-hint">Nenhum produto de fornecedor encontrado.</p>
                    }
                    {!loading && products.map(product => (
                        <div className="brand-picker-row" key={product.id}>
                            <ProductThumb image={product.image} name={product.name} />
                            <div className="brand-picker-info">
                                <strong>{product.name}</strong>
                                <span>{product.supplier} · SKU {product.company_sku} · estoque {Number(product.stock ?? 0).toLocaleString('pt-br')}</span>
                            </div>
                            <Button
                                type="secondary"
                                size="small"
                                text={actionText}
                                loading={picking === product.id}
                                action={() => onPick(product)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export const ProductThumb = ({ image, name }) => (
    <div className="brand-product-thumb">
        {image?.image_url?.small
            ? <img src={image.image_url.small} alt={name} />
            : <Icon name="image" size={18} />
        }
    </div>
);

export default SupplierProductPicker;
